import React, { useState } from 'react';
import PropTypes from 'prop-types';

import DepositTermsContent, {
  depositTermsPropTypes
} from './DepositTermsContent';
import StripeChargeModalPaymentSummaryLineItemV2 from './StripeChargeModalPaymentSummaryLineItemV2';

const MODAL_TITLE = 'Deposit terms';

function MobileTooltipDisplay(props) {
  return (
    <div className="MobileTooltipDisplay">
      <div className="mb6 bb b--lightest-gray">
        <h5 className="font-20 pb3 tc pt1">{MODAL_TITLE}</h5>
      </div>
      <div className="font-16 ph6-md">
        <DepositTermsContent {...props} />
      </div>
    </div>
  );
}

function DesktopModalDisplay(props) {
  return (
    <div className="DesktopModalDisplay pv5">
      <div className="container">
        <div className="row pb3 ph4 mb6">
          <h5 className="font-24 col">{MODAL_TITLE}</h5>
        </div>
        <div className="row pb6 ph8">
          <div className="font-16">
            <DepositTermsContent {...props} />
          </div>
        </div>
      </div>
    </div>
  );
}

/** @param {Record<string, any>} props */
export default function StripeChargeModalDepositLineItem({
  amountInDollars,
  discountedPriceInDollars = null,
  paymentMethod = null,
  tooltipDescription,
  depositRefundPolicy,
  depositSecures,
  finalPaymentTiming,
  ...rest
}) {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const showDiscount =
    paymentMethod && discountedPriceInDollars !== amountInDollars;

  const depositTermsProps = {
    depositRefundPolicy,
    depositSecures,
    finalPaymentTiming,
    tooltipDescription
  };

  return (
    <StripeChargeModalPaymentSummaryLineItemV2
      iconProps={{ name: 'fetch-info' }}
      amountInDollars={amountInDollars}
      {...rest}
      discountedPriceInDollars={showDiscount ? discountedPriceInDollars : null}
      tooltipProps={{
        minWidth: '250px',
        title: <MobileTooltipDisplay {...depositTermsProps} />,
        isVisible: isTooltipOpen,
        onClick: () => setIsTooltipOpen(true),
        onCloseTooltipClick: () => setIsTooltipOpen(false)
      }}
      modalProps={{
        content: <DesktopModalDisplay {...depositTermsProps} />,
        maxWidth: '600px',
        closeButtonClassName: 'pv2 ph2 mt4 mr4 ba b--light-gray bg-white br-100'
      }}
    />
  );
}

MobileTooltipDisplay.propTypes = depositTermsPropTypes;
DesktopModalDisplay.propTypes = depositTermsPropTypes;

StripeChargeModalDepositLineItem.propTypes = {
  amountInDollars: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  paymentMethod: PropTypes.string,
  longDescription: PropTypes.string,
  discountedPriceInDollars: PropTypes.string,
  ...depositTermsPropTypes
};
